import { InventoryManagerFormValues } from "../components/forms/InventoryManagerForm/InventoryManagerForm.types";
import { updateInventoryManagerPayload } from "./../apis/useUpdateInventoryManager/updateInventoryManager.types";

export const convertManagerFormDataToUpdateBody = (
  beforeUpdateManagerData: InventoryManagerFormValues,
  formData: InventoryManagerFormValues
): updateInventoryManagerPayload => ({
  id: formData.id as string,
  imageId: formData.image?.id ?? null,
  firstname: formData.firstname,
  lastname: formData.lastname,
  password: formData.password || undefined,
  repeatPassword: formData.repeatPassword || undefined,
  phoneNumber:
    beforeUpdateManagerData.phoneNumber.replace(/\s/g, "") !==
    formData.phoneNumber.replace(/\s/g, "")
      ? formData.phoneNumber.replace(/\s/g, "")
      : undefined
});
